<template>
  <div class="app-container">
    <div>
      <el-form
        ref="formSearch" :model="queryForm" label-position="top"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="4">
            <!-- 网点编号 -->
            <el-form-item>
              <el-select
                v-model="siteChangeType"
                :placeholder="$t('orderDetails.pleaseChoose')"
                class="postcodeType-class"
                @change="clearNameCode"
              >
                <!--网点名称-->
                <el-option key="1" :label="$t('collectionCenter.siteName')" :value="1" />
                <!--网点编号-->
                <el-option key="2" :label="$t('collectionCenter.siteNum')" :value="2" />
              </el-select>
              <el-input
                v-if="siteChangeType === 1"
                v-model="queryForm.name"
                :placeholder="$t('collectionCenter.pleaseInput')"
                style="width: 100%"
                @input="changeSite"
                @blur="siteBlur('name')"
              />
              <el-input
                v-if="siteChangeType === 2"
                v-model="queryForm.code"
                :placeholder="$t('collectionCenter.pleaseInput')"
                style="width: 100%"
                @input="changeSite"
                @blur="siteBlur('code')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!-- 状态 -->
            <el-form-item :label="$t('collectionCenter.stateZT')">
              <el-select
                v-model="queryForm.siteStatus"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in StatusList"
                  :key="index"
                  :label="item.siteStatusName"
                  :value="item.siteStatus"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!-- 经营模式 -->
            <el-form-item :label="$t('collectionCenter.businessModel')">
              <el-select
                v-model="queryForm.businessModel"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                size="small"
                style="width: 100%"
              >
                <el-option :label="$t('collectionCenter.directSales')" :value="1" /><!--  直营  -->
                <el-option :label="$t('collectionCenter.joinSales')" :value="2" /><!--  加盟  -->
                <el-option :label="$t('collectionCenter.exclusive')" :value="3" /><!--  独家  -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!-- 网点类型 -->
            <el-form-item :label="$t('collectionCenter.dotType')">
              <el-select
                v-model="queryForm.siteType"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                size="small"
                style="width: 100%"
              >
                <el-option :label="$t('collectionCenter.tudo')" :value="null" />
                <el-option :label="$t('collectionCenter.hut')" :value="1" /><!-- 安骏小屋 -->
                <el-option :label="$t('collectionCenter.dot')" :value="2" /><!-- 网点 -->
                <el-option :label="$t('collectionCenter.transferCenter')" :value="3" /><!-- 转运中心 -->
                <el-option :label="$t('collectionCenter.headOffice')" :value="4" /><!-- 总部 -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!-- 是否已签署合同 -->
            <el-form-item :label="$t('collectionCenter.contractSigned')">
              <el-select
                v-model="queryForm.contractSigned"
                :placeholder="$t('placeOrder.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option :label="$t('GlobalSetObj.yes')" :value="1" />
                <el-option :label="$t('GlobalSetObj.No')" :value="0" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="4">
            <!-- 大区 -->
            <el-form-item :label="$t('collectionCenter.region')">
              <el-select
                v-model="queryForm.regionIds"
                :placeholder="$t('placeOrder.pleaseChoose')"
                clearable
                filterable
                multiple
                style="width: 100%"
                collapse-tags
              >
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.zhName + '（' + item.puName + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!-- 网点所属州 -->
            <el-form-item :label="$t('collectionCenter.stateSite1')">
              <el-select
                v-model="queryForm.stateList"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                :multiple-limit="50"
                collapse-tags
                style="width: 100%"
              >
                <el-option
                  v-for="item in StateList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!-- 所属转运中心 -->
            <el-form-item :label="$t('collectionCenter.owningTransitCenter1')">
              <el-select
                v-model="queryForm.departmentId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in departmentList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <!-- 城市 -->
            <el-form-item :label="$t('collectionCenter.citySite')">
              <el-select
                v-model="queryForm.cityList"
                :placeholder="$t('placeOrder.pleaseChoose')"
                :remote-method="getSenderCity"
                class="formTable"
                filterable
                remote
                reserve-keyword
                style="width: 100%"
                multiple
                :multiple-limit="50"
                collapse-tags
                @visible-change="getSenderCity()"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-select
                v-model="postcodeType"
                :placeholder="$t('orderDetails.pleaseChoose')"
                class="postcodeType-class"
                @change="postcodeTypeChange"
              >
                <!--小件派送邮编-->
                <el-option key="1" :label="$t('collectionCenter.smallParcelPostcode')" :value="1" />
                <!--大件派送邮编-->
                <el-option key="2" :label="$t('collectionCenter.largeParcelPostcode')" :value="2" />
                <!--小件揽收邮编-->
                <el-option
                  key="3"
                  :label="$t('collectionCenter.smallParcelCollectionPostcode')"
                  :value="3"
                />
              </el-select>
              <el-input
                v-model="postCode"
                :placeholder="$t('collectionCenter.pleaseInput')"
                style="width: 100%"
                @input="handleChangePostCode"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-button
              icon="el-icon-search" size="small" type="primary"
              @click="searchResources(1)"
            >{{ $t('operationCenter.Procurar') }}
            </el-button>
            <el-button icon="el-icon-refresh-left" size="small" @click="searchResources(2)">
              {{ $t('operationCenter.reset') }}
            </el-button>
            <el-button
              size="small"
              style="margin-left: 10px"
              type="primary"
              @click="exportDateDimension"
            >{{ $t('collectionCenter.allExport') }}
            </el-button>
            <el-button
              size="small" style="margin-left: 10px" type="primary"
              @click="newSiteBtn"
            >{{ $t('collectionCenter.add') }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-tabs v-model="activeNameTab" @tab-click="handleClickTab">
      <!--揽收-->
      <el-tab-pane :label="$t('collectionCenter.lanshou')" name="lanshou">
        <virtual-scroll
          ref="virtualScroll"
          :data="tableData"
          :item-size="76"
          key-prop="id"
          @change="(virtualList) => list = virtualList"
        >
          <el-table
            :data="list"
            :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            row-key="id"
            stripe
            height="600"
          >
            <virtual-column
              min-width="220" type="tree" :label="$t('userManage.realName')"
              prop="name"
            />
            <el-table-column
              v-for="(item, ind) in headerList"
              :key="ind"
              :align="item.align"
              :min-width="item.width"
              :prop="item.prop"
              :show-overflow-tooltip="true"
            >
              <template slot="header">
                <div style="text-align: center">{{ item.label }}</div>
              </template>
              <template slot-scope="scope">
                <div v-if="item.prop === 'status'">
                  <el-tag v-if="scope.row.status === 1">
                    {{ scope.row.statusName }}
                  </el-tag>
                  <el-tag v-else-if="scope.row.status === 0" type="danger">{{ scope.row.statusName }}</el-tag>
                  <span v-else />
                </div>
                <span v-else>
                  {{ scope.row[item.prop] || '' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              align="center" fixed="right" :label="$t('collectionCenter.operation')"
              width="100"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.createTime">
                  <el-button
                    size="small" type="text"
                    @click="seeDetial(scope.row)"
                  >{{ $t('basicData.View') }}</el-button>
                  <el-button
                    size="small" type="text"
                    @click="editSite(scope.row)"
                  >
                    {{ $t('GlobalSetObj.edit') }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </virtual-scroll>
      </el-tab-pane>
      <!--快递-->
      <el-tab-pane :label="$t('collectionCenter.expressDelivery')" name="kuaidi">
        <virtual-scroll
          ref="virtualScroll"
          :data="tableData"
          :item-size="76"
          key-prop="id"
          @change="(virtualList) => list = virtualList"
        >
          <el-table
            :data="list"
            :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            row-key="id"
            stripe
            height="600px"
          >
            <virtual-column
              min-width="220" type="tree" :label="$t('userManage.realName')"
              prop="name"
            />
            <el-table-column
              v-for="(item, ind) in headerList"
              :key="ind"
              :align="item.align"
              :min-width="item.width"
              :prop="item.prop"
              :show-overflow-tooltip="true"
            >
              <template slot="header">
                <div>{{ item.label }}</div>
              </template>
              <template slot-scope="scope">
                <div v-if="item.prop === 'status'">
                  <el-tag v-if="scope.row.status === 1">
                    {{ scope.row.statusName }}
                  </el-tag>
                  <el-tag v-else-if="scope.row.status === 0" type="danger">{{ scope.row.statusName }}</el-tag>
                  <span v-else />
                </div>
                <span v-else>
                  {{ scope.row[item.prop] || '' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" :label="$t('collectionCenter.operation')" width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.createTime">
                  <el-button
                    size="small" type="text"
                    @click="seeDetial(scope.row)"
                  >{{ $t('basicData.View') }}</el-button>
                  <el-button
                    size="small" type="text"
                    @click="editSite(scope.row)"
                  >
                    {{ $t('GlobalSetObj.edit') }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </virtual-scroll>
      </el-tab-pane>
    </el-tabs>
    <!-- 新增 -->
    <new-site ref="newSiteRef" @reSearch="reSearch" />
  </div>
</template>

<script>
import { siteExport, siteQuery, getTransitCenterAll } from '@/api/lanshou';
import {
  getSiteTreeWithTab
} from '@/api/finance/basicData';
import {
  getLgAreaListData,
  regionQueryList,
  selectCity,
  selectInfoByStateTwo
} from '@/api/orderApi';
import { goResourceTaskList } from '@/utils/goExportList.js';
import { Loading } from 'element-ui';
import VirtualScroll, { VirtualColumn } from 'el-table-virtual-scroll';
export default {
  name: 'FranchiseeTimelinessStatistics',
  components: {
    VirtualScroll,
    VirtualColumn,
    'new-site': () => import('./component/newSite.vue')
  },
  data() {
    return {
      departmentList: [], // 转运中心
      postCode: '', // 邮编
      siteChangeType: 1, // 网点编号、网点名称切换
      allSiteListCache: null, // 全部网点数据缓存
      regionList: [],
      cityList: [],
      queryForm: {
        code: '', // 网点编号
        name: '', // 网点名称
        siteStatus: 1, // 站点状态
        businessModel: '', // 经营模式
        siteType: null, // 网点类型 1为小屋,2为网点,3为转运中心,4为总部
        contractSigned: null,
        regionIds: [],
        stateList: [], // 网点所属州
        departmentId: '',
        cityList: [],
        deliveryZipcode: '', // 小件派送邮编
        bulkyDeliveryZipcode: '', // 大件派送邮编
        collectZipcode: '' // 小件揽收邮编
      },
      StatusList: [
        // 状态
        // 0：未启用-停用 1：启用 2：未启用-暂停使用 3：未启用-备用
        { siteStatus: 1, siteStatusName: this.$t('collectionCenter.enable') }, // '启用'
        { siteStatus: 0, siteStatusName: this.$t('collectionCenter.Disable') } // '停用'
        // { siteStatus: 0, siteStatusName: this.$t('collectionCenter.disabledInactive') }, // '未启用-停用'
        // { siteStatus: 2, siteStatusName: this.$t('collectionCenter.disabledSuspended') }, // '未启用-暂停使用'
        // { siteStatus: 3, siteStatusName: this.$t('collectionCenter.disabledStandby') } // '未启用-备用'
      ],
      postcodeType: 1, // 邮编类型下拉框
      tableData: [],
      activeNameTab: 'lanshou',
      StateList: [], // 州
      headerList: [
        // 名称
        // {
        //   label: this.$t('userManage.realName'),
        //   prop: 'name',
        //   width: 180,
        //   align: 'left'
        // },
        // 网点类型
        {
          label: this.$t('collectionCenter.dotTypeCode'),
          prop: 'typeName',
          width: 160,
          align: 'center'
        },
        // 是否已签署合同
        {
          label: this.$t('collectionCenter.contractSigned'),
          prop: 'contractSignedName',
          width: 160,
          align: 'center'
        },
        // 网点编码
        {
          label: this.$t('collectionCenter.branchCode'),
          prop: 'code',
          width: 160,
          align: 'center'
        },
        // 状态
        {
          label: this.$t('collectionCenter.stateZT'),
          prop: 'status',
          width: 160,
          align: 'center'
        },
        // 经营模式
        {
          label: this.$t('collectionCenter.businessModel'),
          prop: 'businessModelName',
          width: 160,
          align: 'center'
        },
        // 创建时间
        {
          label: this.$t('collectionCenter.CreationTime'),
          prop: 'createTime',
          width: 160,
          align: 'center'
        },
        // 创建人
        {
          label: this.$t('collectionCenter.creator'),
          prop: 'createUser',
          width: 160,
          align: 'center'
        },
        // 最新修改时间
        {
          label: this.$t('GlobalSetObj.LastModified'),
          prop: 'updateTime',
          width: 160,
          align: 'center'
        },
        // 最新修改人
        {
          label: this.$t('GlobalSetObj.LatestModifiedBy'),
          prop: 'updateUser',
          width: 160,
          align: 'center'
        }
      ],
      siteList: [],
      dataObj: {},
      selectDate: '',
      // 日期时间范围在一个月以内
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = '';
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      },
      list: [] // 实际渲染列表
    };
  },
  watch: {
    'queryForm.regionIds'(newVal) {
      // 当 regionId 发生变化时，重新设置 StateList
      this.queryForm.stateList = [];
      if (!newVal || newVal.length === 0 || this.regionList.length === 0) {
        this.StateList = [];
        this.getState();
        return;
      }
      const allStates = [];
      newVal.forEach(regionId => {
        const selectedRegion = this.regionList.find(item => item.id === regionId);
        if (selectedRegion && Array.isArray(selectedRegion.states)) {
          // 将州列表添加到总列表中
          selectedRegion.sites.forEach(state => {
            // 避免重复添加
            if (!allStates.some(s => s.label === state.state)) {
              allStates.push({
                id: state.id,
                label: state.state
              });
            }
          });
        }
      });
      this.StateList = allStates;
    }
  },
  created() {
    this.getOperationState('');
    this.getTableData(1);
    this.getRegion();
    this.getState();
    this.getDepartment();
  },
  methods: {
    // 转运中心
    getDepartment() {
      getTransitCenterAll().then((res) => {
        if (res.code === 200) {
          this.departmentList = res.data;
        }
      });
    },
    clearNameCode() {
      this.queryForm.code = '';
      this.queryForm.name = '';
    },
    changeSite(val) {
      // 过滤特殊字符，只保留字母、数字、中文和空格
      const filteredVal = val.replace(/[^a-zA-Z0-9\u4e00-\u9fa5\s-]/g, '');
      if (this.siteChangeType === 1) {
        this.queryForm.code = '';
        this.queryForm.name = filteredVal;
      } else {
        this.queryForm.code = filteredVal;
        this.queryForm.name = '';
      }
    },
    siteBlur(val) {
      const filteredVal = this.queryForm[val].trim();
      if (this.siteChangeType === 1) {
        this.queryForm.code = '';
        this.queryForm.name = filteredVal;
      } else {
        this.queryForm.code = filteredVal;
        this.queryForm.name = '';
      }
    },
    // 切换邮编
    postcodeTypeChange() {
      // 清空
      this.postCode = '';
      this.queryForm.deliveryZipcode = '';
      this.queryForm.bulkyDeliveryZipcode = '';
      this.queryForm.collectZipcode = '';
    },
    // 格式化数据
    handleChangePostCode() {
      this.postCode = this.postCode.trim().replace(/\D/g, '');
      if (this.postcodeType === 1) {
        this.queryForm.deliveryZipcode = this.postCode;
      }
      if (this.postcodeType === 2) {
        this.queryForm.bulkyDeliveryZipcode = this.postCode;
      }
      if (this.postcodeType === 3) {
        this.queryForm.collectZipcode = this.postCode;
      }
    },
    // 大区
    getRegion() {
      regionQueryList(1).then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    // 州
    getState() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    },
    // 获取城市
    getSenderCity(name) {
      const id = null;
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          id,
          name,
          names: this.queryForm.stateList
        }
      };
      selectCity(params, false).then((res) => {
        if (res.code === 200) {
          this.cityList = res.data.records;
        }
      });
    },
    getOperationState(val) {
      if (this.allSiteListCache) {
        this.siteList = this.allSiteListCache;
        return Promise.resolve();
      }
      const load = Loading.service({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: this.$t('collectionCenter.loading'),
        background: 'rgba(250, 250, 250, 0.6)'
      });
      this.queryForm.siteIdList = [];
      const data = {};
      if (val) {
        data.state = val;
      }
      selectInfoByStateTwo(data)
        .then((res) => {
          if (res.code === 200) {
            this.allSiteListCache = res.data.siteList; // 缓存全部网点
            this.siteList = [...this.allSiteListCache]; // 初始化为全量数据
            load.close();
          }
        })
        .finally(() => {
          load.close();
        });
    },
    // 日期维度导出
    exportDateDimension() {
      const load = Loading.service({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: this.$t('collectionCenter.loading'),
        background: 'rgba(250, 250, 250, 0.6)'
      });
      siteExport().then(res => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      }).finally(() => {
        load.close();
      });
    },
    // 页面切换
    handleClickTab() {
      this.getTableData();
    },
    // 搜索、重置
    searchResources(type) {
      if (type === 1) {
        this.getTableData();
      } else {
        this.queryForm = {
          code: '', // 网点编号
          name: '', // 网点名称
          siteStatus: 1, // 站点状态
          businessModel: '', // 经营模式
          siteType: null, // 网点类型 1为小屋,2为网点,3为转运中心,4为总部
          contractSigned: null,
          regionIds: [],
          stateList: [], // 网点所属州
          departmentId: '',
          cityList: [],
          deliveryZipcode: '', // 小件派送邮编
          bulkyDeliveryZipcode: '', // 大件派送邮编
          collectZipcode: '' // 小件揽收邮编
        };
        this.siteChangeType = 1;
        this.postcodeType = 1;
        this.postCode = '';
        this.getTableData();
      }
    },
    // 获取加盟商时效统计列表
    getTableData(val) {
      let loading = null;
      if (val === 1) {
        loading = this.$loading({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: 'loading...',
          background: 'rgba(250, 250, 250, 0.6)'
        });
      }
      const queryForm = JSON.parse(JSON.stringify(this.queryForm));
      queryForm.siteBusinessType = 2;
      const data = {
        ...queryForm
      };
      if (this.activeNameTab === 'lanshou') {
        getSiteTreeWithTab(data)
          .then((res) => {
            if (res.code === 200) {
              console.log(res.data.expressTree, 'lanshou');
              this.tableData = res.data.collectTree;
              if (val === 1) {
                loading.close();
              }
            }
          })
          .catch(() => {
            if (val === 1) {
              loading.close();
            }
          });
      } else {
        queryForm.siteBusinessType = 1;
        const data1 = {
          ...queryForm
        };
        getSiteTreeWithTab(data1)
          .then((res) => {
            if (res.code === 200) {
              console.log(res.data.kuaidi, 'kuaidi');
              this.tableData = res.data.expressTree;
              if (val === 1) {
                loading.close();
              }
            }
          })
          .catch(() => {
            if (val === 1) {
              loading.close();
            }
          });
      }
    },
    // 点击新增
    newSiteBtn(val) {
      this.$refs.newSiteRef.addSiteData();
    },
    // 查看
    seeDetial(row) {
      const load = Loading.service({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: this.$t('collectionCenter.loading'),
        background: 'rgba(250, 250, 250, 0.6)'
      });
      const dataForm = {
        id: row.id
      };
      siteQuery(dataForm).then((res) => {
        if (res.code === 200) {
          const data = res.data;
          data.businessPrincipal = res.data.providerId;
          data.businessType = res.data.businessType ? res.data.businessType.split(',').map(Number) : ''; // 业务类型
          data.siteBusinessTimeData = res.data.businessTimeData ? res.data.businessTimeData : []; // 营业时间
          // 单个网点数据传到子组件
          this.$refs.newSiteRef.seeSiteData(data);
        }
      }).finally(() => {
        load.close();
      });
    },
    // 编辑
    editSite(row) {
      const load = Loading.service({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: this.$t('collectionCenter.loading'),
        background: 'rgba(250, 250, 250, 0.6)'
      });
      const dataForm = {
        id: row.id
      };
      siteQuery(dataForm).then((res) => {
        if (res.code === 200) {
          const data = res.data;
          data.businessPrincipal = res.data.providerId;
          data.businessType = res.data.businessType ? res.data.businessType.split(',').map(Number) : ''; // 业务类型
          data.siteBusinessTimeData = res.data.businessTimeData ? res.data.businessTimeData : []; // 营业时间
          // 单个网点数据传到子组件
          this.$refs.newSiteRef.editSiteData(data);
        }
      }).finally(() => {
        load.close();
      });
    },
    reSearch() {
      this.searchResources(1);
    }
  }
};
</script>

<style scoped>
.app-container >>> .el-drawer__header {
  margin-bottom: 10px;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 20px;
  color: black;
}
.app-container >>> .el-table__expand-icon {
  width: 12px !important;
}
.postcodeType-class ::v-deep .el-input__inner {
  font-size: 13px;
  font-weight: bold;
  border: none;
  padding: 0 !important;
}
</style>
